// extracted by mini-css-extract-plugin
export default {"widgetMsg":"style_widgetMsg__+dfbT"};